export default __webpack_public_path__ + "static/media/clipboards.8bbb2d8b.svg";